import React, { useCallback, useState } from "react";
import Sidebar from "../components/Sidebar";
import Footer from '../components/Footer';
import AuthDialog from "../components/AuthDialog";
import { KenoBalance } from "../components/keno/VCredit";
import { KenoControls } from "../components/keno/KenoControls";
import { KenoBoard } from "../components/keno/KenoBoard";
import { KenoToolbar } from "../components/keno/KenoToolbar";
import { KenoDialogs } from "../components/keno/KenoDialogs";
import { useKeno } from "../components/keno/useKeno";
import { KenoBetHistory } from "../components/keno/KenoBetHistory";
import { LiveStatsPanel } from "../components/keno/LiveStatsPanel";
import { useLiveStatsDock } from '../components/keno/LiveStatsDockContext';
import { OriginalsBar } from "../components/keno/OriginalsBar";
import "../components/keno/keno.css";

export default function Keno() {
  const game = useKeno();
  const statsPreference = useLiveStatsDock();
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState("login");
  const [view, setView] = useState(() => statsPreference.restore ? 'stats' : null);
  const [statsDock, setStatsDock] = useState(null);
  const [desktopStatsDock, setDesktopStatsDock] = useState(null);
  const promptAuth = (mode = 'login') => { game.stop(); setView(null); setAuthMode(mode); setAuthOpen(true); };
  const closeStats = useCallback(() => { setView(null); document.querySelector('[data-testid="keno-stats"]')?.focus({ preventScroll: true }); }, []);
  const openView = (next) => {
    if (next === 'stats' && view === 'stats') statsPreference.setDocked(false);
    setView((current) => current === next ? null : next);
  };
  return <div className="keno-page desktop-original" data-testid="keno-page">
    <Sidebar onAuth={promptAuth} balanceSlot={<KenoBalance wallet={game.displayWallet} demo={game.demo} loading={game.walletLoading} onAuth={promptAuth} onWallet={() => { game.stop(); openView("wallet"); }} disabled={game.busy || game.auto} />} />
    <main className="content-shift keno-main">
      <div className="keno-frame" data-testid="keno-frame">
        <div className="keno-game"><KenoControls game={game} desktopStatsDockRef={setDesktopStatsDock} /><KenoBoard game={game} /><div ref={setStatsDock} className="mobile-stats-dock" data-testid="keno-stats-dock" /></div>
        <KenoToolbar game={game} onView={openView} />
      </div>
      <OriginalsBar game="keno" gameBusy={game.busy || game.auto} onAuth={promptAuth} />
      <KenoBetHistory game={game} />
    </main>
    <div className="content-shift originals-footer" data-testid="keno-footer"><Footer /></div>
    <AuthDialog open={authOpen} onOpenChange={setAuthOpen} mode={authMode} setMode={setAuthMode} />
    <KenoDialogs view={view} setView={setView} game={game} />
    {view === "stats" && <LiveStatsPanel key={game.owner} owner={game.owner} onClose={closeStats} dockTarget={statsDock} desktopDockTarget={desktopStatsDock} />}
  </div>;
}